// extracted by mini-css-extract-plugin
module.exports = {"root":"RelatedButtons_root__2EmG1"};